import { defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, onMounted, nextTick, onBeforeUnmount, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import Swiper from '@/components/layout/Swiper.vue';
import SearchBar2 from '@/components/layout/SearchBar2.vue';
import Header2 from '@/components/layout/header2.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import bus from 'vue3-eventbus'
import SideComponent from '@/components/common/SideComponent.vue';
import Loading from '@/components/common/Loading.vue';
import { wexinShare, getWechatShareImgUrl } from '@/utils/wxshare.js';
import { trackContentView, CONTENT_VIEW_TYPES } from '@/utils/contentView.js';
import { getRouteId } from '@/utils/routeParams';
import { VISUAL_QINGDAO_FROM, buildVisualQingdaoBackRoute } from '@/utils/seoUrl.js';
// import VideoPlayer from '@/components/common/VideoPlayer';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
// import "videojs-hlsjs";
import "../../../node_modules/vue3-video-play/dist/style.css";
import { videoPlay } from "vue3-video-play";
import HLS from 'hls.js';
// import {qualityLevels} from "videojs-contrib-quality-levels";
// import 'videojs-contrib-hls';

export default defineComponent({
	components: {
		PageLoading,
		Header2,
		Menu,
	    Swiper,
	    SearchBar2,
	    Footer,
	    SideComponent,
	    Loading,
	    // VideoPlayer,
	    videoPlay,
	},
	props: {
		options: {
		    type: Object,
		    default() {
		        return {};
		    }
		}
	},
	setup() {
		let {ctx, proxy} = getCurrentInstance();
		const router = useRouter();
	    const route = useRoute();
	    
		const data = reactive({
			isMobile: false,
			isLoading:true,
			showHeader: true,
			loginStyle: "min-width:141px;",
			mobileIconStyle: "color:rgba(223, 58, 8, 1);",
			showListIcon: true,
			imageSrc: '',
			//定义一个imageNew变量来接收裁剪之后的图片
			imageNew: '',
			picCats: [

      		],
      		videos:[],
		    videoDetail:{},
		    page:1,
      		nomore:true,
      		keyword:'',
      		isVideoLoading: true,
	      	player: null,
	      	videoOptions: {
		        controls: true,//开启交互，即是用户可控。
		        muted: true,//开启视频时是否静音
		        fluid: true,//根据外层css样式大小，自动填充宽高！比较实用，可搭配响应式
		        reload: "metadata",//重载
		        //其余设置根据需求添加！
		        poster: '',//视频封面
		        sources: [],
				techOrder: ['html5'],
				bufferTime: 7, // 单位：秒，建议5-10秒平衡卡顿与延迟
				// html5: {
				//     hlsjsConfig: {
				//         enableWorker: true,
				//         enableSoftwareAES: true
				//     }
				// },
				html5: {
				    hls: {
				      enableLowInitialPlaylist: false, // 关闭初始低画质锁定
				      overrideNative: true            // 强制使用Video.js的HLS处理逻辑
				    }
				},
				hls: {
				    overrideNative: true
				},
				// plugins: {
				//   videoJsResolutionSwitcher: {
				//     default: 'low',
				//     dynamicLabel: true
				//   },
				//   hlsjs: {
				//     debug: true,
				//     enableLowInitialPlaylist: true,
				//     smoothQualityChange: true,
				//     maxBufferLength: 30,
				//     smoothSwitching: true
				//   }
				// },
				// hlsjsConfig: {
				//   debug: true,
				//   xhrSetup: function (xhr, url) {
				//     xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
				//   }
				// }
		    },
		    sources:{
	            src: '',
	            type: "video/mp4"
	        },
	        views: 0,

		});

		const showMenu = ref(proxy.$menus);
		provide('showMenu', showMenu);

		const outerStyleStr = ref("position:relative;left:10%;top:40%;transform:translate(-10%,-40%);width:auto;");
		provide('outerStyleStr', outerStyleStr);

		const styleStr = ref("height:45px;");
		provide('styleStr', styleStr);

		const showSearchText = ref(false);
		provide('showSearchText', showSearchText);

		const getImageUrl = (name) => {
		    return proxy.$utils.getImageUrl(name);
		};

		//点击裁剪按钮
		const updateImageSrc = (updateImageSrc) => {
		  	imageNew.value = updateImageSrc
		}
		const store = useStore();		
	    const getVideoList = (keyword='',page=1) => {
	    	data.keyword = keyword;
        	store.dispatch("common/getPicLists",{
	        	page: page,
	        	filter: keyword,
	        	type: 2,
	        }).then((res) => {
	        	if(res.data.length > 0){
	        		if(page == 1){
	        			data.videos = res.data;
	        		}else{
	        			data.videos = data.videos.concat(res.data);
	        		}
					
					if(res.data.length < res.pagination.pageSize){
						data.nomore = true;
					}else{
						data.nomore = false;
					}
				}else{
					data.nomore = true;
				}        
	        	// data.pagination = res.pagination;
	        	data.isVideoLoading = false;
	        	data.page += 1;
	        }).catch(err=>{
	        	data.isVideoLoading = false;
	        })
        }
        
	    
      	const id = getRouteId(route);
      	const getVideo = (id=0) => {
      		store.dispatch("common/getPicVideoDetail",{
	        	id:id,
	        }).then((res) => {
	        	console.log(res,"video");
	        	data.videoDetail = res
	        	data.videoDetail.size = proxy.$utils.round(data.videoDetail.size / 1024 / 1024,2);
	        	data.views = res.views ?? 0;
	        	trackContentView(store, CONTENT_VIEW_TYPES.image, id, data.views).then((v) => {
	        		data.views = v;
	        	});
	        	data.videoOptions.poster = res.thumb;
				data.sources.src = res.url;
				data.videoOptions.sources.push(data.sources);
				// console.log(data.videoOptions,"videoOptions");
	        	if(data.videoDetail.keywords == null){
	        		data.videoDetail.keywords = [];
	        	}
	        	// if(parseInt(imginfo.width) < parseInt(imginfo.height)){
        		// 	data.videoDetail.direction = 3;
        		// }else if(parseInt(imginfo.width) > parseInt(imginfo.height)){
        		// 	data.videoDetail.direction = 2;
        		// }else if(parseInt(imginfo.width) == parseInt(imginfo.height)){
        		// 	data.videoDetail.direction = 1;
        		// }
	        	proxy.$utils.getImageSize(res.thumb).then((imginfo)=>{
	        		// console.log(imginfo,'imginfo');
	        		if(parseInt(imginfo.width) < parseInt(imginfo.height)){
	        			data.videoDetail.direction = 3;
	        		}else if(parseInt(imginfo.width) > parseInt(imginfo.height)){
	        			data.videoDetail.direction = 2;
	        		}else if(parseInt(imginfo.width) == parseInt(imginfo.height)){
	        			data.videoDetail.direction = 1;
	        		}

	        	});
	        	if(document.documentElement.clientWidth < 768){
					initPlayer();
				}else{
					
				}
	        	
	        	// console.log(data.videoDetail,"videosize");
	        	bus.emit('showFooter',true);
	        	wxshare(res);
	        })
      	}
      	const initPlayer = () => {
	      data.player = videojs(proxy.$refs.videoPlayer, data.videoOptions, () => {
	        console.log('Player is ready');
	      });
	      // const video = proxy.$refs.video;
	      // if (HLS.isSupported()) {
	      //   const hls = new HLS();
	      //   hls.loadSource(data.sources.src);
	      //   hls.attachMedia(video);
	      //   hls.on(HLS.Events.MANIFEST_PARSED, () => {
	      //     video.play();
	      //   });
	      // } else {
	      //   console.error('HLS.js is not supported in this browser.');
	      // }
	    }
	    // const initPlayer = () => {
	    //   const video = proxy.$refs.video;
	    //   if (HLS.isSupported()) {
	    //     const hls = new HLS();
	    //     hls.loadSource(data.sources.src);
	    //     hls.attachMedia(video);
	    //     hls.on(HLS.Events.MANIFEST_PARSED, () => {
	    //       video.play();
	    //     });
	    //   } else {
	    //     console.error('HLS.js is not supported in this browser.');
	    //   }
	    // }
      	const getVideoInfo = (url) => {
	    	return new Promise((resolve, reject) => {
				const video = document.createElement('video') // 创建video对象
				video.src = url // url地址
				const canvas = document.createElement('canvas') // 创建 canvas 对象
				const ctx = canvas.getContext('2d') // 绘制2d
				video.crossOrigin = 'anonymous' // 解决跨域问题，也就是提示污染资源无法转换视频
				video.currentTime = 1 // 第一秒帧
				// console.log(video,"video")
				video.oncanplay = (e) => {
					// console.log('wh', e.target.videoWidth, e.target.videoHeight);
					let obj = {
						width: e.target.videoWidth,
						height: e.target.videoHeight,
					}
					resolve(obj);
				    
				}
			})
		}
		const wxshare = (share_data) => {
			const protocol = window.location.protocol; // 协议 (e.g., "https:")
			const hostname = window.location.hostname; // 域名 (e.g., "example.com")
			let url = protocol+'//'+hostname;
			if(hostname.indexOf("www") == -1){
				url = protocol+'//www.'+hostname;
			}
			url = url+route.fullPath;
			
			store.dispatch("common/Jssdk",{
				url:url
			}).then((res) => {
				// console.log(res,'jssdk');
				//微信加签              
                // var shareWxLink = encodeURIComponent(url);加密
                let shareData = {
                    title: share_data.title, // 分享标题
                    desc:'',
                    link: url,
                    imgUrl: getWechatShareImgUrl(store.state.common.siteInfo) // 分享图标
                };
                //引用
                wexinShare(res, shareData);
	        })
		}
      	
				
		const viewBox = ref(null);
        const scroll = (val) => {
			if(val == 'top'){				
				viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
		       
			}else if(val == 'bottom'){				
				viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "end", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
   
			}
		}

		onMounted(async()=>{
			getVideoList();
			getVideo(id);			
        	await nextTick()
        	setTimeout(() => {
		        data.isLoading = false;
		        viewBox.value.scrollIntoView({
			        behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
			        block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
			        inline: "center", // 定义水平滚动方向的对齐
			    });
		    }, 600);
		    console.log("页面数据更新完毕了")
        })

		const refData = toRefs(data);

		const showBackButton = computed(() => route.query.from === VISUAL_QINGDAO_FROM);

		function goBackToSource() {
			if (route.query.from === VISUAL_QINGDAO_FROM) {
				router.push(buildVisualQingdaoBackRoute());
				return;
			}
			router.back();
		}

		return {
			...refData,
			getImageUrl,
			updateImageSrc,
			getVideo,
			getVideoList,
			viewBox,
			scroll,
			getVideoInfo,
			wxshare,
			showBackButton,
			goBackToSource,
		}
	},
	created() {

	},
	mounted() {
		this.$nextTick(() => {
			this.init();
		});
	},
	methods: {
		init() {
			if(document.documentElement.clientWidth < 768){
				this.isMobile = true;
			}else{
				this.isMobile = false;
			}
			// this.videoOptions.poster = this.videoDetail.thumb;
			// this.videoOptions.sources[0].src = this.videoDetail.url;
			console.log(this.isMobile,'this.isMobile');
			if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
				console.log(this.isMobile,'this.isMobile-2');
			    // this.$refs.video.setAttribute('x5-video-player-type', 'h5')
			    // this.$refs.video.setAttribute('x5-video-player-fullscreen', 'false')
			    // this.$refs.video.setAttribute('x5-video-orientation', 'portraint')
			}
		},
		activeStyle(item) {		
			if(item.ratio_w == null || item.ratio_h == null || item.ratio_w == "" || item.ratio_h == "") {
				(async () => {
				    let size = await this.$utils.getImageSize(item.thumb);
				    // console.log(size,"size");
				    item.ratio_w = size.width;
				    item.ratio_h = size.height;
				})();

			}
			let object = {};
			object.width = item.ratio_w*200/item.ratio_h+'px';

			return object;
		},	

		handleMouseEnter(event) {
	      event.target.play();
	    },
	    handleMouseLeave(event) {
	      event.target.pause();
	    },
		loadMore() {
			this.isVideoLoading = true;
			this.getVideoList(this.keyword, this.page);
		},
		changeVideoinfo(id){
			let that = this;
			this.getVideo(id);			
		},
		realTime(data) {
			console.log(data,"data");
  			var previews = data;
  			this.previews = data
  		},
  		initPlayer() {
            this.$nextTick(() => {
                let playerOption = {
                    preload: 'auto', // 预加载
                    autoplay: true, // 自动播放
                    controls: true,
                    techOrder: ['html5', 'flvjs', 'flash'], // 这里的顺序一定要 'flvjs' 在 'flash' 前面，要不然 flv 格式的就无法播放了
                    // 如果报 app.js:242798 Uncaught TypeError: this.el_.vjs_getProperty is not a function 错误，只保留 'flash' 就不报错了
                    // 报错 The "flash" tech is undefined. Skipped browser support check for that tech. 可以查看 videojs-flash 里面 node_modules 查看需要的 video.js 的版本，然后修改video.js的版本就可以了
                    flash: {
                        hls: { withCredentials: false },
                        swf: SWF_URL // 引入静态文件swf
                    },
                    flvjs: {
                        mediaDataSource: {
                            cors: true,
                            withCredentials: false,
                        },
                    },
                    sources: [
                        {
                            src: this.videoDetail.url,
                            type: this.getType(this.streamType)
                        }
                    ],
                }

                this.player = videojs(this.$el.querySelector('.videoPlayer'), playerOption, function onPlayerReady () {
                    console.log('onPlayerReady', this)

                })
                this.player.errorDisplay.close();
            })
        },


	},
})